/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type useTenantsPaginationQueryVariables = {
    count?: number | null;
    cursor?: string | null;
    tenantId: string;
};
export type useTenantsPaginationQueryResponse = {
    readonly " $fragmentRefs": FragmentRefs<"useTenants_tenants">;
};
export type useTenantsPaginationQuery = {
    readonly response: useTenantsPaginationQueryResponse;
    readonly variables: useTenantsPaginationQueryVariables;
};



/*
query useTenantsPaginationQuery(
  $count: Int = 100
  $cursor: String
  $tenantId: ID!
) {
  ...useTenants_tenants_Nd6Pz
}

fragment useTenants_tenants_Nd6Pz on RootQueryType {
  node(id: $tenantId) {
    __typename
    ... on Tenant {
      tenants(after: $cursor, first: $count) {
        edges {
          cursor
          node {
            id
            name
            insertedAt
            __typename
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": 100,
            "kind": "LocalArgument",
            "name": "count"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cursor"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "tenantId"
        } as any
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v3 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "cursor"
        } as any,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "useTenantsPaginationQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        },
                        {
                            "kind": "Variable",
                            "name": "cursor",
                            "variableName": "cursor"
                        },
                        {
                            "kind": "Variable",
                            "name": "tenantId",
                            "variableName": "tenantId"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "useTenants_tenants"
                }
            ],
            "type": "RootQueryType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "useTenantsPaginationQuery",
            "selections": [
                {
                    "alias": null,
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "tenantId"
                        }
                    ],
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        (v2 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v3 /*: any*/),
                                    "concreteType": "TenantConnection",
                                    "kind": "LinkedField",
                                    "name": "tenants",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TenantEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "cursor",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Tenant",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "name",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "insertedAt",
                                                            "storageKey": null
                                                        },
                                                        (v1 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "endCursor",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v3 /*: any*/),
                                    "filters": null,
                                    "handle": "connection",
                                    "key": "useTenants_tenants",
                                    "kind": "LinkedHandle",
                                    "name": "tenants"
                                }
                            ],
                            "type": "Tenant",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "813bae8e560c0251e0d1defdc3e118ab",
            "id": null,
            "metadata": {},
            "name": "useTenantsPaginationQuery",
            "operationKind": "query",
            "text": "query useTenantsPaginationQuery(\n  $count: Int = 100\n  $cursor: String\n  $tenantId: ID!\n) {\n  ...useTenants_tenants_Nd6Pz\n}\n\nfragment useTenants_tenants_Nd6Pz on RootQueryType {\n  node(id: $tenantId) {\n    __typename\n    ... on Tenant {\n      tenants(after: $cursor, first: $count) {\n        edges {\n          cursor\n          node {\n            id\n            name\n            insertedAt\n            __typename\n          }\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n    id\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'a38c5fd6107a62911145b5d7585b5c5c';
export default node;
